<ng-container [ngSwitch]="type">
  <div *ngSwitchCase="'svg-icon'" class="image-container">
    <svg-icon [icon]="name"></svg-icon>
  </div>
  <div *ngSwitchCase="'mat-icon'" class="image-container">
    <mat-icon [class.material-icons-outlined]="outlined">{{ name }}</mat-icon>
  </div>
  <div *ngSwitchCase="'img'" class="image-container">
    <img [src]="name" [alt]="name" />
  </div>
  <div *ngSwitchCase="'material-icon'" class="image-container">
    <span [ngClass]="{ 'material-icons-outlined': outlined, 'material-icons': !outlined }">{{
      name
    }}</span>
  </div>
  <div *ngSwitchCase="'lucide-icon'" class="image-container">
    <lucide-icon [name]="name" [size]="size"></lucide-icon>
  </div>
</ng-container>
